<div [id]="id + '676de8d5-14c5-4166-9a72-d0551067a550'" class="form-group" [class.no-label]="!label && !labelFor" [class.lbl-top]="labelTop === true">
  <ng-content></ng-content
  ><label *ngIf="label && labelFor" [id]="id + '882ab9fc-989f-4859-b420-8644c29ecda7'" [for]="labelFor">
    {{ label }}
  </label>
  <label *ngIf="optional" [id]="id + 'bbe03789-f1b3-4786-b564-cbd14d3a426f'" [for]="labelFor" class="optional float-right">{{
    'optional' | commonWording | async
  }}</label>
</div>
